module.exports = __webpack_public_path__ + "static/img/00.f98d0e1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/commodity/03/00.jpg
// module id = W1s3
// module chunks = 0